export default __webpack_public_path__ + "static/media/gold-medal.f7135ba9.png";